//获取购物车商品总条目数
export const GET_CART_TOTAL_NUM = "GET_CART_TOTAL_NUM";
//设置购物车商品总条目数
export const SET_CART_TOTAL_NUM = "SET_CART_TOTAL_NUM";
//加车
export const ADD_CART = "ADD_CART";
//修改购物车商品数量
export const CHANGE_SKU_NUM = "CHANGE_SKU_NUM";



// WEBPACK FOOTER //
// ./src/store/cart/type.js